import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, input, Input, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { enGB } from 'date-fns/locale/en-GB';
import { materialSymbols } from '../../../shared/constants/material-symbols';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';

@Component({
    selector: 'app-date-picker',
    templateUrl: 'date-picker.component.html',
    styleUrl: './date-picker.component.scss',
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatePickerComponent),
            multi: true
        },
        provideDateFnsAdapter(),
        { provide: MAT_DATE_LOCALE, useValue: enGB }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})


export class DatePickerComponent implements ControlValueAccessor {

  @Input() id: string = '';
  @Input() name?: string = '';
  @Input("value") _value?: Date;
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() errorMessage?: string = '';
  @Input() minDate?: Date | null =  null;
  @Input() maxDate?: Date | null =  null;
  @Input() isFromBallotSummary: boolean = false;

  isDisabled: boolean = false;
  hasError: boolean = false;
  isFocused: boolean = false;

  calendar = materialSymbols.calendar;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.hasError = this.errorMessage != '';
  }

  dateFilter = (date: Date | null): boolean => {
    let isMinDate = true;
    let isMaxDate = true;

    if (!date) return false;
    if (this.minDate == null && this.maxDate == null) return true;
    if(this.minDate != null) isMinDate = date >= new Date(this.minDate);
    if(this.maxDate != null) isMaxDate = new Date(this.maxDate) >= date;

    return isMinDate && isMaxDate;
  }

  onChange: (value: Date) => void = () => {};
  onTouched: any = () => { };

  get value(): Date | undefined {
    return this._value;
  }

  set value(val: Date) {
    this._value = val;
    this.onChange(val);
    this.cdr.markForCheck();
  }

  // Called by parent component to set value programatically.
  writeValue(obj: Date): void {
    this._value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    this.cdr.markForCheck();
  }

  public setFocusToTrue() {
    this.isFocused = true;
  }

  public getDisplayDate(dateValue: Date | undefined) : string {
    if (!dateValue) return '';
    const date = new Date(dateValue);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

}
